import RightArrowIcon from "@/assets/colorable/right_arrow.svg?react";
import HdlLogo from "@/assets/images/hdl_buch_tag.png";
import RefluencedLogo from "@/assets/images/refluenced_logo_with_text_neg.svg";
import VentureKickLogo from "@/assets/images/venture_kick.png";
import {useHelpUrl} from "@/hooks/useNavigationHooks";
import {Can} from "@/permissions";
import {useLocation} from "@tanstack/react-router";
import type {FC} from "react";
import {useTranslation} from "react-i18next";

const ROUTES_WITHOUT_FOOTER = ["/chat"] as const;

const Footer: FC = () => {
  const {t} = useTranslation("common");
  const location = useLocation();
  const helpUrl = useHelpUrl();

  const shouldHideFooter = ROUTES_WITHOUT_FOOTER.some(page => location.pathname.includes(page));

  if (shouldHideFooter) {
    return <></>;
  }

  return (
    <footer className="bg-good-grey-900 font-roboto pt-20 pb-12">
      <div className="container mx-auto flex flex-col gap-12 px-8">
        <div className="grid grid-cols-2 gap-x-12 gap-y-8 md:grid-cols-3 lg:grid-cols-4">
          <div className="flex flex-col items-center gap-4 md:items-start">
            <span className="text-2xl text-white">{t("sitemap")}</span>
            <a
              href="/?landing"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("forBrands")}
            </a>
            <a
              href="/for-agencies/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("forAgencies")}
            </a>
            <a
              href="/for-influencers/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("forInfluencers")}
            </a>
            <a
              href="/plans/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("Prices")}
            </a>
            <a
              href="/blog/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("blog")}
            </a>
            <a
              href={helpUrl}
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("help_and_faq")}
            </a>
            <a
              href="/about/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("aboutUs")}
            </a>
          </div>
          <div className="flex flex-col items-center gap-4 md:items-start">
            <span className="text-2xl text-white">{t("more")}</span>
            <a
              target="_blank"
              href="https://www.instagram.com/refluenced/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("Instagram")}
            </a>
            <a
              target="_blank"
              href="https://www.linkedin.com/company/refluenced/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              LinkedIn
            </a>
            <Can I="create" a="MailToSupport">
              <a
                href={`mailto:info@refluenced.com`}
                className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
                {t("email")}
              </a>
            </Can>
          </div>
          <div className="flex flex-col items-center gap-4 md:items-start">
            <span className="text-2xl text-white">{t("legal")}</span>
            <a
              href="/legal/cookie-policy/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("cookiePolicy")}
            </a>
            <a
              href="/legal/impressum/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("imprint")}
            </a>
            <a
              href="/legal/privacy-policy/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("privacy_policy")}
            </a>
            <a
              href="/legal/toc/"
              className="hover:text-neutral-grey-light w-fit cursor-pointer text-sm text-white no-underline transition-all duration-150">
              {t("ToS")}
            </a>
          </div>
          <div className="col-span-2 flex w-full flex-row flex-wrap items-center justify-between gap-10 md:col-span-3 md:gap-20 lg:col-span-1 lg:flex-col lg:items-end lg:justify-start lg:gap-10">
            <img src={VentureKickLogo} alt="" className="h-10 shrink-0" />
            <img src={HdlLogo} alt="" className="h-14 shrink-0" />
            <img src={RefluencedLogo} alt="" className="h-10 shrink-0" />
          </div>
        </div>
        <div className="flex flex-wrap justify-between gap-8">
          <span className="text-neutral-white-dark text-sm whitespace-nowrap">{t("refluencedCopyright")}</span>
          <button
            onClick={() =>
              window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
              })
            }
            className="flex gap-4">
            <RightArrowIcon className="text-neutral-white-dark h-4 -rotate-90" />
            <span className="text-neutral-white-dark text-sm whitespace-nowrap">{t("backToTop")}</span>
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
